import script from "./PriceTag1.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceTag1.vue?vue&type=script&setup=true&lang=js"

import "./PriceTag1.vue?vue&type=style&index=0&id=1ec90c0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec90c0a"]])

export default __exports__